import React, { useEffect, useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../../Kryzen Alpha App/Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcClapperboard, FcCollaboration, FcInspection } from "react-icons/fc";
import SimpleButton from "../../../Components/layouts/simple_button";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";

const ViewPodcast = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
    const [historyLoading, setHistoryLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/podcast/view/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting podcasts!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);


    const getHistory = async (id) => {
      try {
        setHistoryLoading(true);
  
        const response = await performRequest(
          "GET",
          `/postPlanning/get-podcast-history/${id}`
        );
  
        if (response.status === 200) {
          setHistory(response.data?.data || []);
        }
      } catch (err) {
        CustomErrorResponse(err);
      } finally {
        setHistoryLoading(false);
      }
    };
  
    useEffect(() => {
      if (id) {
        getHistory(id);
      }
    }, [id]);


  if (loading) {
    return <LoadingPage />;
  }

  const linkifyText = (text) => {
    if (!text) return "N/A";

    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcCollaboration className="fs-2 me-1" />
                  Podcast
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Podcast</h2>
            </div>

            <div className="card-body">
              {!data ? (
                <div className="text-center text-muted">No data found</div>
              ) : (
                <>
                  <h3> Planning Podcast </h3>
                  <hr className=""></hr>
                  {/* <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast Name
                    </label>
                    <div className="w-100 col">
                      {data?.podcastName || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Description</label>
                    <div className="w-100 col">
                      {linkifyText(data?.podcastDescription || "N/A")}
                    </div>
                  </div> */}

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast Branding Assets
                    </label>
                    <div className="w-100 col">
                      {data?.podcastBrand || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Guest Name</label>
                    <div className="w-100 col">{data?.guestName || "N/A"}</div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast Type
                    </label>
                    <div className="w-100 col">
                      {data?.podcastType || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      {" "}
                      Podcast Language{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.podcastLanguage || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast Series Name
                    </label>
                    <div className="w-100 col">
                      {data?.podcastseriesName || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast Planning Date
                    </label>
                    <div className="w-100 col">
                      {data?.podcastDate
                        ? new Date(data.podcastDate).toLocaleDateString()
                        : "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Guest Previous podcast reference
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.guestPrvRef || "N/A")}
                    </div>
                  </div>

                  {/* <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Guest City</label>
                    <div className="w-100 col">{data?.guestCity || "N/A"}</div>
                  </div> */}

                  <hr></hr>
                  <h3>Podcast Shooting </h3>
                  <hr></hr>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast Venue
                    </label>
                    <div className="w-100 col">
                      {data?.podcastVenue || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Shooting Date
                    </label>
                    <div className="w-100 col">
                      {data?.shootingDate || "N/A"}
                    </div>
                  </div>

                  {/* <hr className="mt-4 mb-0" /> */}
                    <hr></hr>
                  <div className="card mb-2">
                    <div className="card-header">
                      <h3 className="card-title">Podcast Schedule History</h3>
                    </div>

                    <div className="table-responsive">
                      <table className="table table-vcenter table-bordered card-table">
                        <thead>
                          <tr>
                            <th>Sr.</th>
                            <th>Schedule ID</th>
                            <th>Type</th>
                            <th>Schedule Name</th>
                            <th>Live Date</th>
                            <th>Images</th>
                            <th>Script</th>
                            <th>Generated By</th>
                            <th>Created At</th>
                          </tr>
                        </thead>

                        <tbody>
                          {historyLoading ? (
                            <tr>
                              <td colSpan="9" className="text-center py-4">
                                <div
                                  className="spinner-border spinner-border-sm text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>

                                <span className="ms-2">
                                  Loading schedule history...
                                </span>
                              </td>
                            </tr>
                          ) : history?.length > 0 ? (
                            history.map((item, index) => (
                              <tr key={item?.id || index}>
                                <td>{index + 1}</td>

                                <td>{item?.scheduleId || "N/A"}</td>

                                <td>
                                  <span className="badge bg-blue-lt">
                                    {item?.type || "N/A"}
                                  </span>
                                </td>

                                <td>{item?.scheduleName || "N/A"}</td>

                                <td>{item?.liveDate || "N/A"}</td>

                                <td>
                                  {Array.isArray(item?.images) &&
                                  item.images.length > 0 ? (
                                    <div className="d-flex flex-wrap gap-2">
                                      {item.images.map((image, imageIndex) => (
                                        <a
                                          key={imageIndex}
                                          href={image}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <img
                                            src={image}
                                            alt={`Schedule ${imageIndex + 1}`}
                                            style={{
                                              width: "70px",
                                              height: "70px",
                                              objectFit: "cover",
                                              borderRadius: "6px",
                                              border: "1px solid #ddd",
                                            }}
                                          />
                                        </a>
                                      ))}
                                    </div>
                                  ) : (
                                    <span className="text-muted">No Media</span>
                                  )}
                                </td>

                                <td
                                  style={{
                                    minWidth: "250px",
                                    maxWidth: "350px",
                                    whiteSpace: "pre-wrap",
                                  }}
                                >
                                  {item?.script || "N/A"}
                                </td>

                                <td>{item?.generatedBy || "N/A"}</td>

                                <td>
                                  {item?.createdAt
                                    ? new Date(item.createdAt).toLocaleString(
                                        "en-IN"
                                      )
                                    : "N/A"}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="9" className="text-center py-5">
                                <h4 className="mb-1">
                                  No Schedule History Found
                                </h4>

                                <span className="text-muted">
                                  No schedule history is available for this
                                  podcast.
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Questions</label>
                    <div className="w-100 col">
                      {linkifyText(data?.podcastQuestions) || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Camera / Lence Name
                    </label>
                    <div className="w-100 col">{data?.cameraName || "N/A"}</div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Raw Podcast Folder Path
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.rawFolderPath || "N/A")}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast Credits
                    </label>
                    <div className="w-100 col">
                      {data?.podcastCredits || "N/A"}
                    </div>
                  </div> */}

                  {/* <hr></hr>
                  <h3>Podcast Editing </h3>
                  <hr></hr>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast Editor Name
                    </label>
                    <div className="w-100 col">
                      {data?.podcastEditor || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Deadline
                    </label>
                    <div className="w-100 col">
                      {data?.taskdedline || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast Coming Soon Poster
                    </label>
                    <div className="w-100 col">
                      {data?.podCastComingSoonPoster ? (
                        <LazyImageComponent
                          width="40%"
                          src={data?.podCastComingSoonPoster}
                          alt=" Podcast Coming Soon Poster"
                          // className="rounded"
                        />
                      ) : (
                        " Podcast Coming Soon Poster Not Available"
                      )}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast Thumbnail
                    </label>
                    <div className="w-100 col">
                      {data?.rowImageGuest ? (
                        <LazyImageComponent
                          width="40%"
                          src={data?.rowImageGuest}
                          alt="Raw Image"
                          // className="rounded"
                        />
                      ) : (
                        "Podcast Thumbnail"
                      )}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast First Draft File Path
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.podcastFirstDraft || "N/A")}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast edit complated
                    </label>
                    <div className="w-100 col">
                      {data?.ispodcastComplated ? "Yes" : "No" || "N/A"}
                    </div>
                  </div> */}

                  {/* <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast Coming Soon Description
                    </label>
                    <div className="w-100 col">
                      {data?.podCastComingSoonDescription || "N/A"}
                    </div>
                  </div> */}

                  {/* <hr></hr>
                  <h3>Podcast Final </h3>
                  <hr></hr>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast Final Footage Path
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.podCastFinalFootage || "N/A")}
                    </div>
                  </div> */}

                  {/* <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast Publish Title
                    </label>
                    <div className="w-100 col">
                      {data?.podCastPublishTitle || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Podcast Publish Description
                    </label>
                    <div className="w-100 col">
                      {data?.podCastPublishDescription || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Mark as Published (Upload proof)
                    </label>
                    <div className="w-100 col">
                      {data?.markAsPublished ? (
                        <LazyImageComponent
                          width="40%"
                          src={data?.markAsPublished}
                          alt="  Mark as Published "
                          // className="rounded"
                        />
                      ) : (
                        "  Mark as Published  Not Available"
                      )}
                    </div>
                  </div> */}

                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <SimpleButton
                        buttonText="Edit Podcast"
                        href={`/edit-podcast/${id}`}
                      />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewPodcast;
